import React, { useCallback, useContext, useEffect } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/styles";
import PublicIcon from "@material-ui/icons/Public";
import IconButton from '@material-ui/core/IconButton';
import CachedIcon from '@material-ui/icons/Cached';
import InputAdornment from '@material-ui/core/InputAdornment';


const useStyles = makeStyles((theme) => ({
    textFieldSize: {
        width: "100%",
        display: "flex"
    },
}))

export default function UrlTextField(props) {
    const classes = useStyles();
    const state = useContext(AppContext);
    const s = state.strings;
    const { urlFieldValue, onUrlFieldChange, getTextFromUrl, getTextOnEnter } = props
    return (
        <div style={{display: "flex", justifyContent: "center", width: "100%" }}>
            <TextField style={{flex: "1 1 auto", minWidth: 0}}
                autoFocus
                label={s.provideURLExtraction}
                id={'url'}
                variant="outlined"
                className={classes.textFieldSize}
                onChange={(evt) => onUrlFieldChange(evt.target.value)}
                onBlur={getTextFromUrl}
                onKeyDown={getTextOnEnter}
                value={urlFieldValue}
                size="small"
            />
            <IconButton style={{marginLeft: 8, flex: "0 0 auto"}} onClick={getTextFromUrl}>
                <CachedIcon />
            </IconButton>
        </div>
    );

}